/*
 * Authors: mariushirjanu
 * Created: 23/06/2022
 */
import { Component, Input, OnInit } from '@angular/core';
import { FaqDataService } from './faq-data.service';
import { IFaq } from '../../../type_definitions/datatypes';
import { util } from '../util';
import { IFaqItem } from '../../main/faq/list/faq-list.component';

// display a link to the FAQ by using the faq id and question as label
@Component({
  selector: 'faq-link',
  template:
    `
      <div class="faq-item">
        <activity-indicator *ngIf="loading"></activity-indicator>

        <div *ngIf="!loading && data">
            <a href="#/faq/{{faqCode}}" target="_blank">
              <i *ngIf="!hideInfoIcon" class="fa fa-info-circle info-icon right"></i> {{ data.id }}: {{ data.question }}
            </a>
        </div>
      </div>
    `
})
export class FaqLinkComponent implements OnInit {
  @Input() public faqCode?:string;
  @Input() public data:IFaqItem;
  @Input() public hideInfoIcon:boolean;
  public loading:boolean;

  constructor(
    private faqDataService:FaqDataService
  ) {
    /***/
  }

  public ngOnInit():void {
    if (!this.data) {
      this.loadData();
    }
  }

  private loadData():void {
    if (this.faqCode) {
      this.loading = true;
      this.faqDataService.getFaqByCode(this.faqCode)
        .then((res:IFaq) => {
          if (res) {
            this.data = util.copyAndExtend(res);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}